export default {
  title: 'HwangJunpil♥︎HanHeesong 2019.04.13 Sat, April 13, 2019 3:00 pm Grand Hill Convention 1F Floria',
  husband: ['Hwang ', 'Junpil'],
  wife: ['Han ', 'Heesong'],
  date: 'Sat, April 13, 2019 3:00 pm',
  location: 'Grand Hill Convention 1F Floria',
  locations: {
    address: 'Address',
    addressContent: 'Seoul 602 Yeoksam-ro, Daecheon-dong, Gangnam-gu, Seoul, <br /> <strong>Grand Hill Convention</strong>',
    subway: 'Subway',
    subwayContent: 'Take the shuttle bus to Exit 1 of Samsung Station on Line 2 or <br />walk 5 minutes from Exit 2',
    bus: 'Bus',
    busContent: 'Main bus 143, 146, 341, 360, 401 <br />Branch bus 2413, 3411, 3422, 4318, 4419, 917, 11-3 <br />Wide area bus 9407, 6900',
  },
  invite: 'Dear',
  greeting: [
    'One of the glittering April,',
    'Putting both hands in front of everyone',
    'We promise to make a way together.',
    'Let this heart walk without change',
    'Many encouragement and blessings.'],
  telWho: ['To Groom', 'To Bride'],
  deposit: 'Address',
  money: 'Money',
  moneySend: 'Money Send',
  tossAppSet: 'Install the Toss App',
  copy: 'Copy',
  huobi: 'Huobi Exchange Go'
};


// WEBPACK FOOTER //
// ./src/locales/en-US/home.ts